var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v(" By closing this window you agree to our use of cookies "),_c('span',{staticClass:"underline cursor-pointer",on:{"click":_vm.handleClick}},[_vm._v("Find out more")])])}
var staticRenderFns = []

export { render, staticRenderFns }